import React from 'react'
import { EntityInfoSectionLayoutProps } from './EntityInfoSectionLayout.types'
import styles from './EntityInfoSectionLayout.module.scss'
// import cl from 'classnames'

const EntityInfoSectionLayoutComponent = (props: EntityInfoSectionLayoutProps) => {
  const {
    leftContainerNode,
    rightContainerNode
  } = props

  return (
    <div className={styles.infoContainer}>
      <div className={styles.infoLeftContainer}>
        {leftContainerNode}
      </div>

      <div className={styles.infoRightContainer}>
        {rightContainerNode}
      </div>
    </div>
  )
}

const EntityInfoSectionLayout = EntityInfoSectionLayoutComponent
export { EntityInfoSectionLayout }
